<div *ngIf="consultationReportError">
  <p class="fs-5 mb-0">
    {{ consultationReportError }}
  </p>
</div>
